<template>
  <div class="financial-report-tab">
    <!-- 有财报数据时显示列表 -->
    <div v-if="financialReports.length > 0" class="financial-reports-content">
      <div
        v-for="(report, index) in financialReports"
        :key="index"
        class="report-item"
        @click="handleReportClick(report)"
      >
        <div class="report-icon">
          <i class="el-icon-document"></i>
        </div>
        <div class="report-info">
          <div class="report-name">{{ report.name }}</div>
        </div>
      </div>
    </div>

    <!-- 暂无数据提示 -->
    <div v-else class="empty-data-wrapper">
      <div class="empty-data-container">
        <div class="empty-icon">
          <i class="el-icon-document"></i>
        </div>
        <div class="empty-text">暂无财报数据</div>
        <div class="empty-description">当前没有相关的财务报表信息记录</div>
      </div>
    </div>

    <el-dialog :title="pdfDialogTitle" :visible.sync="pdfDialogVisible" width="1000px">
      <div class="pdf-preview-container">
        <PdfComponent :pdfUrl="pdfUrl" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PdfComponent from '@/components/pdf/PdfComponent.vue'

export default {
  name: 'FinancialReportTab',
  components: {
    PdfComponent
  },
  props: {
    financialReportInfoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // PDF预览对话框控制
      pdfDialogVisible: false,
      pdfDialogTitle: '',
      pdfUrl: '',
      
      // 财务报表数据
      _financialReports: [
        {
          name: '2025年梦幻岛半年报.pdf',
          url: '/admin/file/cqjy/financeAdd/3d25e09ac9d84ed986d06a75c3b727a3.pdf'
        },
        {
          name: '2025年一季报.pdf',
          url: '/admin/file/cqjy/financeAdd/2025firstQuarter.pdf'
        },
        {
          name: '2024年年报.pdf',
          url: '/admin/file/cqjy/financeAdd/2024annualReport.pdf'
        }
      ]
    }
  },
  computed: {
    financialReports() {
      return this.mapFinancialReportInfoList(this.financialReportInfoList)
    }
  },
  methods: {

    // 处理报表点击
    handleReportClick(report) {
      this.pdfUrl = report.url
      this.pdfDialogTitle = '财报预览：' + report.name
      this.pdfDialogVisible = true
    },

    mapFinancialReportInfoList(data) {
      if (!data || !Array.isArray(data)) {
        return []
      }
      
      const reports = []
      
      data.forEach(item => {
        // 如果有files字段，解析files中的文件
        if (item.files) {
          try {
            const files = JSON.parse(item.files)
            if (Array.isArray(files)) {
              files.forEach(file => {
                reports.push({
                  name: file.FilesName || file.name || '未知文件',
                  url: file.imgUrl || file.url || '未知URL'
                })
              })
            }
          } catch (error) {
            console.warn('解析files字段失败:', error)
          }
        }
      })
      
      return reports
    }
  }
}
</script>

<style lang="less" scoped>
.financial-report-tab {
  width: 100%;
  height: 100%;
  min-height: 160px;
}

// 有数据时的内容容器
.financial-reports-content {
  width: 100%;
}

// 无数据时的居中容器
.empty-data-wrapper {
  width: 100%;
  height: 100%;
  min-height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}

// 财务报表样式
.financial-reports-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.report-item {
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #e9ecef;

  &:hover {
    background-color: #e3f2fd;
    border-color: #90caf9;
    transform: translateX(4px);
    box-shadow: 0 2px 8px rgba(144, 202, 249, 0.3);
  }

  .report-icon {
    width: 48px;
    height: 48px;
    background-color: #f5f5f5;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;

    i {
      font-size: 24px;
      color: #1890ff;
    }
  }

  .report-info {
    flex: 1;
  }

  .report-name {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 4px;
  }

  .report-size {
    font-size: 14px;
    color: #999;
  }

  .report-action {
    color: #1890ff;
    i {
      font-size: 18px;
    }
  }
}

// PDF预览容器样式
.pdf-preview-container {
  height: 600px;
  width: 100%;
  overflow: hidden;
}

// 暂无数据样式
.empty-data-container {
  text-align: center;
  padding: 20px 20px;

  .empty-icon {
    margin-bottom: 16px;
    
    i {
      font-size: 48px;
      color: #d9d9d9;
      transition: all 0.3s ease;
      
      &:hover {
        color: #bfbfbf;
        transform: scale(1.05);
      }
    }
  }

  .empty-text {
    font-size: 16px;
    font-weight: 500;
    color: #595959;
    margin-bottom: 6px;
    line-height: 1.4;
  }

  .empty-description {
    font-size: 13px;
    color: #8c8c8c;
    line-height: 1.5;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .empty-data-container {
    padding: 15px 15px;
    
    .empty-icon i {
      font-size: 36px;
    }
    
    .empty-text {
      font-size: 14px;
    }
    
    .empty-description {
      font-size: 12px;
    }
  }
}
</style>